import {Component, Input, OnDestroy, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {CirfService} from "../cirf.service";
import {FormGroup} from "@angular/forms";
import {CirfMatterContactInfo} from "../cirf-matter-contact-info";
import {dropDowns} from "../../shared/drop-downs";
import {CirfInsuranceDetail} from "../cirf-insurance-detail";
import {Cirf} from "../cirf";
import {CirfDocument} from "../cirf-document";
import {FileUploadService} from "../../common/file-upload/file-upload.service";
import {ConfirmDialogService} from "../../common/confirm-dialog/confirm-dialog.service";
import {Utils} from "../../common/utils";
import {CIRF_NAME_KEYS, DpBooleanValueTypes, UploadedFileDescription} from "../../shared/constants";
import {ConnectDialog} from "../../common/confirm-dialog/connect-dialog";
import {CirfConfigService} from "../config/cirf-config-service";
import {CIRF_CONFIG_KEYS} from "../config/cirf-config-keys";
import {CirfUdf} from "../cirf-udf";

@Component({
    selector: 'dp-matter-property-info',
    templateUrl: './matter-property-info.component.html'
})
export class MatterPropertyInfoComponent implements OnInit, OnDestroy  {

    @Input() sectionKey: string;

    cirfMatterContactInfo: CirfMatterContactInfo;
    cirfInsuranceDetail: CirfInsuranceDetail;
    matterPurchasersCapacityOptions: any;
    matterTypeText: string;
    yesNoOptionsMandatory : any = dropDowns.yesNoOptionsMandatory;

    yesNoOnlyOptions : any = dropDowns.yesNoOnlyOptions;

    cirfDocuments: CirfDocument[] = [];
    scheduler : any;
    showMatterInfoStep: boolean = false;
    showMatterNotesStep: boolean = false;
    showInsuranceStep: boolean = false;

    mostRecentTaxBillDescription = UploadedFileDescription.mostRecentTaxBill;

    constructor(public router : Router,
                private route: ActivatedRoute ,
                public cirfService : CirfService,
                public fileUploadService: FileUploadService,
                public confirmDialogService : ConfirmDialogService,
                private cirfConfigService: CirfConfigService
                ) {

    }


    ngOnInit() {

        this.startPolling();
        this.matterTypeText = this.cirfService.matterTypeText;
        this.cirfMatterContactInfo  =  this.cirfService.cirfMatterContactInfo;
        this.cirfInsuranceDetail = this.cirfService.fireInsuranceDetail;
        let numberOfClients = this.cirfService.clients.length;
        if(this.cirf.isProvinceAB() || this.cirf.isProvinceNB()){
            this.matterPurchasersCapacityOptions = dropDowns.matterPurchasersCapacityOptionsAB;
        } else {
            this.matterPurchasersCapacityOptions = Utils.getMatterPurchasersCapacityOptions(numberOfClients, this.cirf?.provinceCode);
        }

        this.onChanges();
        Utils.invokeFieldLevelValidation(this.cirfFormGroup);
        this.showMatterNotesStep = !this.cirfConfigService.isFieldHidden('matterNotes');
        this.showInsuranceStep = this.isInsuranceApplicable()
            && !(this.cirfConfigService.areFieldsForSectionHidden('fireInsuranceDetail')
                && this.cirfConfigService.areAllUDFsHidden(CIRF_CONFIG_KEYS.fireInsuranceDetailUdf,this.insuranceUdfs && this.insuranceUdfs.length));
        this.showMatterInfoStep = !(this.cirfConfigService.areFieldsForSectionHidden('matterContactInfo')
            && this.cirfConfigService.areAllUDFsHidden(CIRF_CONFIG_KEYS.matterContactInfoUdf,this.matterContactInfoUdfs && this.matterContactInfoUdfs.length));
    }


    get cirfFormGroup() : FormGroup{
        return (this.cirfService.cirfFormGroup as FormGroup);
    }
    
     
    isInsuranceApplicable() : boolean {
        return this.cirf && this.cirf.isInsuranceApplicable();
    }


    backToClientListPage() : void {
        this.saveMatterForm(['../../cirfs']);
    }

    onChanges(): void {
       this.cirfService.saveChangesOnCirfFormChanges();
    }

    async saveMatterForm(route? : string[]) {
        if(!!this.cirfService.cirf) {
            let cirf = await this.cirfService.updateCirf('INPROGRESS');
            if(cirf){
                if (route) {
                    this.router.navigate(route, {relativeTo: this.route});
                }
            }
        }
        else if(route){
            this.router.navigate(route, {relativeTo: this.route});
        }
    }



    documentUploaded(event) {
        this.startPolling();
    }


    get cirf() : Cirf {
        return this.cirfService.cirf;
    }

    deleteDocument(document: CirfDocument) {
        let connectDialog = new ConnectDialog();
        connectDialog.message = 'Are you sure you want to delete this document?'
        connectDialog.dialogType = 'WARNING';
        this.confirmDialogService.confirmDialog(connectDialog).subscribe(
            res => {
                if (res) {
                    this.fileUploadService.deleteCirfDocument(this.cirf.cirfGuid, String(document.id))
                        .subscribe((res)=>{
                            this.startPolling();
                        });
                }
            }
        )

    }

    public startPolling() : void {
        this.getCirfDocuments();
        clearInterval(this.scheduler);
        this.scheduler = setInterval(() => {
            this.getCirfDocuments();
        }, 5000);
    }

    stopPolling() : void {
        window.clearInterval(this.scheduler);
    }

    getCirfDocuments() : void {
        this.fileUploadService.getCirfDocuments(this.cirf.cirfGuid).subscribe(
            (documents)=>{
                this.cirfDocuments = documents.filter(doc => !doc.sourceId);
                if(this.cirfDocuments && !this.cirfDocuments.length){
                    this.stopPolling();
                } else {
                    if(this.cirfDocuments.every( doc => doc.isVirusClean())){
                        this.stopPolling();
                    }
                }
            })
    }

    ngOnDestroy() : void {
        this.cirfService.updateCirf('INPROGRESS');
        this.stopPolling();
    }

    isNotResidingAtSubjectProperty(): boolean {
        return this.matterContactInfoFormGroup?.value?.residingAtSubjectProperty == DpBooleanValueTypes.NO;
    }

    isClosingAddressVisible() : boolean {
        return this.cirf?.isMatterMortgage()? this.isNotResidingAtSubjectProperty() : true;
    }

    get matterContactInfoFormGroup() : FormGroup {
        return this.cirfService.cirfFormGroup.get('cirfMatterData')['controls'].matterContactInfo;
    }

    get matterContactInfoUdfFieldKey() : string {
        return CIRF_CONFIG_KEYS.matterContactInfoUdf;
    }

    get matterContactInfoUdfs() : CirfUdf[] {
        return this.cirfMatterContactInfo.matterContactInfoUdfs;
    }

    get insuranceFormGroup() : FormGroup {
        return this.cirfService.cirfFormGroup.get('cirfMatterData')['controls'].fireInsuranceDetail;
    }

    get insuranceUdfFieldKey() : string {
        return CIRF_CONFIG_KEYS.fireInsuranceDetailUdf;
    }

    get insuranceUdfs() : CirfUdf[] {
        return this.cirfInsuranceDetail.insuranceUdfs;
    }

    get addressLine1LabelDisplay(): string{
        if (this.cirf?.isMatterPurchase()) {
            return '(Pre-Closing Address) Address 1';
        }
        if(this.cirf?.isMatterMortgage()) {
            return '(Mailing Address) Address 1';
        }
        return '(Post-Closing Address) Address 1'
    }

    isSelectedSectionMatterContactInfo() : boolean {
        return this.sectionKey == CIRF_NAME_KEYS.matterContactInfo.key;
    }

    isSelectedSectionInsuranceDetails() : boolean {
        return this.sectionKey == CIRF_NAME_KEYS.newInsuranceDetails.key;
    }

    isSelectedSectionMatterNotes() : boolean {
        return this.sectionKey == CIRF_NAME_KEYS.matterNotes.key;
    }

    isSelectedSectionAdditionalAttachments() : boolean {
        return this.sectionKey == CIRF_NAME_KEYS.additionalAttachments.key;
    }

    get mostRecentTaxBillDocument() : CirfDocument {
        if(this.cirfDocuments && this.cirfDocuments.length){
            return this.cirfDocuments.find(doc => doc.description == this.mostRecentTaxBillDescription);
        } else {
            return null;
        }
    }

}
